<template>
  <qx-card-form title="事故登记">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>
<script>
export default {
  data () {
    return {
      baseForm: {
        accidentResponsibilityOptions: [],
        accidentTypeOptions: [],
        form: [
          {
            label: '报案日期',
            value: 'reportTime',
            type: 'date',
            disabled: false,
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '出险日期',
            value: 'accidentTime',
            type: 'date',
            disabled: false,
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '事故类型',
            value: 'accidentType',
            type: 'select',
          },
          {
            label: '事故地点',
            value: 'accidentAddress',
            type: 'input',
          },
          {
            label: '事故司机',
            value: 'accidentDriver',
            type: 'input',
          },
          {
            label: '事故经过',
            value: 'accidentPassing',
            type: 'input',
            disabled: false,
            placeholder: '请输入事故经过，最多200字',
            attr: {
              type: 'textarea',
              maxlength: 200,
            },
          },
          {
            label: '出险原因',
            value: 'accidentRemark',
            type: 'input',
            disabled: false,
            placeholder: '请输入出险原因，最多200字',
            attr: {
              type: 'textarea',
              maxlength: 200,
            },
          },
          {
            label: '责任归属',
            value: 'accidentResponsibility',
            type: 'select',
            disabled: false,
          },
          {
            label: '事故图片',
            // vehicleAccidentPicFileIds
            value: 'vehicleAccidentPicFileList',
            type: 'img',
            accept: 'image/*',
            fileSize: 51200000000,
            disabled: false,
            attr: {
              limit: 5,
            },
            default: [],
          },
          {
            label: '事故认定书',
            // vehicleAccidentSurePicFileIds
            value: 'vehicleAccidentSurePicFileList',
            type: 'img',
            accept: 'image/*',
            fileSize: 51200000000,
            disabled: false,
            attr: {
              limit: 5,
            },
            default: [],
          },
        ],
        rules: {
          reportTime: [
            { required: true, message: '请选择报案日期', trigger: 'blur' },
          ],
          accidentTime: [
            { required: true, message: '请选择出险日期', trigger: 'blur' },
          ],
          accidentResponsibility: [
            { required: true, message: '请选择责任归属', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    setList (optionList) {
      this.baseForm.accidentResponsibilityOptions = optionList[0];
      this.baseForm.accidentTypeOptions = optionList[1];
    },
    // 初始化图片列表数据
    initImgList (initData, imgListFieldName) {
      if (initData[imgListFieldName] && initData[imgListFieldName].length) {
        for (let item of initData[imgListFieldName]) {
          item.id = item.fileId;
          item.url = item.fileUrl;
        }
      }
    },
    // 提交/缓存图片列表数据
    subImgList (formData, imgListFieldName, fildIdsName) {
      if (formData[imgListFieldName] && formData[imgListFieldName].length) {
        let picFileIds = [];
        for (let item of formData[imgListFieldName]) {
          item.fileId = item.id;
          item.fileUrl = item.url;
          picFileIds.push(item.fileId);
        }
        formData[fildIdsName] = picFileIds.join();
      }
    },
    // 显示和禁用逻辑
    showAndDisabledLogic (data) {
      let formItemDisabled = false;

      let accidentRegisterState = `${data.accidentState}`;
      if (this.$route.query.accidentRegisterState) {
        accidentRegisterState = `${this.$route.query.accidentRegisterState}`;
      }

      switch (accidentRegisterState) {
        case '1':
          // 事故登记
          formItemDisabled = false;
          break;
        case '2':
          // 定损登记
          formItemDisabled = true;
          break;
        case '3':
          // 维修登记
          formItemDisabled = true;
          break;
        case '4':
          // 理赔登记
          formItemDisabled = true;
          break;
        default:
          break;
      }
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: formItemDisabled,
      });
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 这里处理的格式必须和详情接口返回的一样
        formData.reportTime = this.formatDate(formData.reportTime);
        formData.accidentTime = this.formatDate(formData.accidentTime);
        this.subImgList(formData, 'vehicleAccidentPicFileList', 'vehicleAccidentPicFileIds');
        this.subImgList(formData, 'vehicleAccidentSurePicFileList', 'vehicleAccidentSurePicFileIds');
      }
      console.log('车辆登记参数', formData);
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        delete formData.vehicleAccidentPicFileList;
        delete formData.vehicleAccidentSurePicFileList;
      }
      // console.log('提交参数', formData);
      return formData;
    },
    init (data = {}) {
      this.$refs.baseForm.reset();
      // 这里处理接口或者缓存返回的数据
      this.showAndDisabledLogic(data);
      this.initImgList(data, 'vehicleAccidentPicFileList');
      this.initImgList(data, 'vehicleAccidentSurePicFileList');
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
